import FormError from 'components/FormError/FormError';
import React, { Component } from 'react';
import Tooltip from '../Tooltip/Tooltip';

import './InputField.scss';

interface InputFieldProps {
    inputtype: string;
    inputid: string;
    inputvalue: string | number;
    classNames?: string;
    labeltext: string;
    handlechange?: Function;
    autocomplete?: boolean;
    error?: string;
    showHide?: boolean;
    tooltip?: string;
    tooltipTitle?: string;
    blurValidation?: any;
    placeholder?: string;
    min?: number;
    max?: number;
}

class InputForm extends Component<InputFieldProps> {
    state = {
        hidden: true,
    };

    _toggleVisibility = (e: any) => {
        e.preventDefault();
        this.setState({ hidden: !this.state.hidden });
    };

    render() {
        const {
            inputtype,
            inputid,
            inputvalue,
            classNames = '',
            labeltext,
            handlechange = () => {},
            error = '',
            showHide = false,
            tooltip = '',
            tooltipTitle = '',
            blurValidation = () => {},
            ...rest
        } = this.props;
        const { hidden } = this.state;
        return (
            <div className={`form-input-group ${classNames}`}>
                <label className="input-label" htmlFor={inputid}>
                    {labeltext}
                </label>
                <input
                    className={'input-field ' + inputtype}
                    id={inputid}
                    name={inputid}
                    autoComplete="off"
                    type={hidden ? inputtype : 'text'}
                    value={inputvalue}
                    onChange={(e: any) => handlechange(e)}
                    onBlur={(e: any) => blurValidation(e)}
                    {...rest}
                />
                {showHide && (
                    <input
                        className={`show-hide-icon ${!hidden ? 'visible' : ''}`}
                        onClick={this._toggleVisibility}
                        type="text"
                        defaultValue="show or hide"
                    />
                )}
                {tooltip && <Tooltip header={tooltipTitle || labeltext} tooltipText={tooltip} />}
                {error && <FormError error={error} />}
            </div>
        );
    }
}

export default InputForm;
